module.exports = __webpack_public_path__ + "media/images/pages/careers-week/julie_simmons-eb0a4930ca3d1ae41880049e8e8c8e6d.jpg";